import React, { createContext, useContext, useEffect, useState } from 'react';
import apiClient from '../lib/apiClient';

const HotelContext = createContext(null);

export const HotelProvider = ({ children }) => {
  const [hotel, setHotel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHotel = async () => {
      try {
        const data = await apiClient.get('/api/Hotel/GetHotel');
        setHotel(data);

        // Apply branding to the document
        if (data?.faviconUrl) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) favicon.href = data.faviconUrl;
        }
        if (data?.hotelName) {
          document.title = data.hotelName;
        }
        if (data?.primaryColor) {
          document.documentElement.style.setProperty('--color-primary', data.primaryColor);
        }
        if (data?.secondaryColor) {
          document.documentElement.style.setProperty('--color-secondary', data.secondaryColor);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHotel();
  }, []);

  return (
    <HotelContext.Provider value={{ hotel, loading, error }}>
      {children}
    </HotelContext.Provider>
  );
};

export const useHotel = () => useContext(HotelContext);
